import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PickupChoiceModel} from 'src/app/models/chat-request.model';
import {ChatService} from 'src/app/services/chat.service';
import {UserService} from 'src/app/services/user.service';
import {UserModel} from 'src/app/models/user.model';

@Component({
  selector: 'shc-pickup-choice-item',
  templateUrl: './pickup-choice-item.component.html',
  styleUrls: ['./pickup-choice-item.component.scss'],
})
export class PickupChoiceItemComponent implements OnInit {
  @Input() pickupChoiceItem: PickupChoiceModel;
  @Input() chatId: string;
  @Output() notifyChoiceMade = new EventEmitter<PickupChoiceModel>();

  userDetail: UserModel;
  isSubmitting = false;
  errorMessage = '';

  constructor(
    private chatService: ChatService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService.get().subscribe(res => {
      this.userDetail = res;
    });
  }

  get isBuyer(): boolean {
    return this.pickupChoiceItem?.buyer_id === this.userDetail?.id;
  }

  choose(method: 'pickup' | 'delivery') {
    if (!this.isBuyer || this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.errorMessage = '';
    this.chatService.updatePickupChoice(this.chatId, method).subscribe({
      next: (res: any) => {
        this.pickupChoiceItem = res?.data ? res.data : res;
        this.notifyChoiceMade.emit(this.pickupChoiceItem);
        this.isSubmitting = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message || 'Er ging iets mis.';
        this.isSubmitting = false;
      }
    });
  }
}
